angular.module('bbl.services.pusher', [])
  .factory('PusherPubsub', ['$rootScope', 'pubsub', '$timeout', pusherPubsubFactory])
  .service('PusherUpdates', ['$rootScope', 'PUSHER_ID', pusherUpdatesService]);

function pusherUpdatesService($rootScope, PUSHER_ID, pubsub) {
  var pusher = null,
    conference_channel = null,
    conference_events = [
      'conference_locked',
      'conference_ended'
    ],
    call_channel = null,
    call_events = [
      'caller_joined',
      'caller_left',
      'caller_muted',
      'caller_deafened',
      'caller_nudged',
      'name_recorded',
      'caller_raised_hand',
      'hand_raised_at',
      'caller_name_change',
      'caller_booted',
    ],
    floor_channel = null,
    floor_events = [
      'speaker_change'
    ],
    sms_channel = null,
    sms_events = [
      'message_received',
    ],
    call_play_events = [
      'play_started',
      'play_stopped',
    ];

  var broadcastEvent = function(channelName, eventName, eventResponse) {
    $rootScope.$broadcast('pusher:' + channelName + ':' + eventName, eventResponse);
    $rootScope.$broadcast('pusherReceivedEvent', {
      channel: channelName,
      name: eventName,
      response: eventResponse
    });
  };

  this.initConnection = function() {
    if(pusher) {
      return;
    }

    pusher = new Pusher(PUSHER_ID);
    conference_channel = pusher.subscribe('conference_events');

    this.bindEvents(conference_events, conference_channel, 'conference');
  };

  var lines = {};
  this.subscribeTo = function(line_id) {
    // do not sobscribe to same line multiple times
    if(lines[line_id]) {
      return;
    }

    sms_channel = pusher.subscribe('sms_'+line_id);
    call_channel = pusher.subscribe('call_events_'+line_id);
    floor_channel = pusher.subscribe('floor_events_'+line_id);

    this.bindEvents(sms_events, sms_channel, 'sms');
    this.bindEvents(call_events, call_channel, 'call');
    this.bindEvents(floor_events, floor_channel, 'floor');

    lines[line_id] = {
      sms: sms_channel,
      call: call_channel,
      floor: floor_channel
    };
  };

  this.subscribeToChannel = function(line_id, channelName) {
    // do not sobscribe to same line multiple times
    if(lines[line_id] && lines[line_id][channelName]) {
      return;
    }

    var channel = pusher.subscribe(channelName+'_events_'+line_id);
    var events = {
      sms: sms_events,
      call: call_events,
      floor: floor_events,
      call_play: call_play_events,
    }[channelName];
    this.bindEvents(events, channel, channelName);

    lines[line_id] = angular.merge({}, lines[line_id]);
    lines[line_id][channelName] = channel;
  };

  this.bindEvents = function(events, channel, channelName) {
    angular.forEach(events, function(eventName) {
      channel.bind(eventName, function(response) {
        broadcastEvent(channelName, eventName, response);
      });
    });
  };
}

function pusherPubsubFactory($rootScope, pubsub, $timeout) {
  var evTypes = {
    CALLER_JOINED: 'CALLER_JOINED',
    CALLER_LEFT: 'CALLER_LEFT',
    CALLER_MUTED: 'CALLER_MUTED',
    CALLER_DEAFENED: 'CALLER_DEAFENED',
    CALLER_NUDGED: 'CALLER_NUDGED',
    NAME_RECORDED: 'NAME_RECORDED',
    SPEAKER_CHANGE: 'SPEAKER_CHANGE',
    SMS_RECEIVED: 'SMS_RECEIVED',
    CALLER_NAME_CHANGE: 'CALLER_NAME_CHANGE',
    CALLER_BOOTED: 'CALLER_BOOTED',
  };

  function $pub() {
    pubsub.pub.apply(pubsub, arguments);
    // since we're out of angular's loop, call a delayed scope apply
    $timeout(function() {});
  }

  var mapConferenceCall = function(conferenceCall) {
    var confCall = conferenceCall instanceof Array ? conferenceCall[0] : conferenceCall;

    // ensure conference has `fields` prop
    if(confCall.fields !== undefined) {
      var pk = confCall.pk;
      confCall = confCall.fields;
      confCall.id = pk;
    }

    return confCall;
  };

  var eventsLog = {};
  var isDuplicateEvent = function(confCall, event) {
    var duplicated = false, evkey = confCall.id+':'+event.name;

    // ensure not duplicate
    // FIXME: nasty solution for prevent duplicated events.
    if (eventsLog[evkey] && new Date() - eventsLog[evkey] < 1500) {
      duplicated = true;
    }

    eventsLog[evkey] = new Date();

    return duplicated;
  };

  /**
   * Required data for this event:
   * conferenceCall
   * - caller object with all the informations
   * - required object that is resulting from this API call
   * bridgeId
   * /bridges/api/v1/conferencecall/:conferenceCallId
   */
   $rootScope.$on('pusher:call:caller_joined', function onCallerJoin(event, data) {
    var confCall = mapConferenceCall(data.conferenceCall);

    if (isDuplicateEvent(confCall, event)) {
      return;
    }

    // uuid used for screensharing identification
    confCall.uuid = data.unique_id || null;

    var evData = angular.extend({}, data, {conferenceCall: confCall});
    $pub(evTypes.CALLER_JOINED, evData);
  });

  /**
    * Required data for this event:
    * bridgeId - the bridge that the caller is
    * conferenceCallId - the id of the caller
    * conferenceCallName - the name of the caller
    */
  $rootScope.$on('pusher:call:caller_left', function onCallerLeft(event, data) {
    var confCall = mapConferenceCall(data.conferenceCall);

    if (isDuplicateEvent(confCall, event)) {
      return;
    }

    var evData = angular.extend({}, data, {conferenceCall: confCall});
    $pub(evTypes.CALLER_LEFT, evData);
  });

  /**
   * Required data for this event:
   * bridgeId
   * mutedStatus
   * mutedCallId
   */
   $rootScope.$on('pusher:call:caller_muted', function onCallerMuted(event, data) {
    var evData = angular.extend({}, data, {isMuted: data.mutedStatus.toString() === 'true'});

    $pub(evTypes.CALLER_MUTED, evData);
  });

  /**
   * Required data for this event:
   * bridgeId
   * deafenedStatus
   * deafenedCallId
   */
   $rootScope.$on('pusher:call:caller_deafened',  function onCallerDefened(event, data) {
    var evData = angular.extend({}, data, {isDeafened: data.deafenedStatus.toString() === 'true'});

    $pub(evTypes.CALLER_DEAFENED, evData);
  });

  /**
    * Required data for this event:
    * bridgeId
    * nudgedCallId
    */
  $rootScope.$on('pusher:call:caller_nudged', function onCallerNudget(event, data) {
    var evData = angular.extend({}, data, {isNudged: true});
    $pub(evTypes.CALLER_NUDGED, evData);

    $timeout(function(){
      evData.isNudged = false;
      $pub(evTypes.CALLER_NUDGED, evData);
    }, 5000);
  });

  /**
   * Required data for this event:
   * bridgeId
   * conferenceCall
   */
  $rootScope.$on('pusher:call:name_recorded', function onNameRecorded(event, data) {
    if(!data.conferenceCall) {return;}
    var confCall = mapConferenceCall(data.conferenceCall);

    var evData = angular.extend({}, data, {conferenceCall: confCall});
    $pub(evTypes.NAME_RECORDED, evData);
  });

  $rootScope.$on('pusher:floor:speaker_change', function onSpeakerChange(event, data) {
    var confCall = mapConferenceCall(data.conferenceCall);

    if (isDuplicateEvent(confCall, event)) {
      return;
    }

    var evData = angular.extend({}, data, {conferenceCall: confCall});
    $pub(evTypes.SPEAKER_CHANGE, evData);
  });

  $rootScope.$on('pusher:sms:message_received', function onSmsReceived(event, data) {
    var call = {id: data.call_id};

    if (isDuplicateEvent(call, event)) {
      return;
    }

    $pub(evTypes.SMS_RECEIVED, data);
  });

  $rootScope.$on('pusher:call:caller_name_change', function onCallerNameChange(event, data) {
    var call = {id: data.call_id};

    if (isDuplicateEvent(call, event)) {
      return;
    }

    console.log('caller_name_change', data);
    $pub(evTypes.CALLER_NAME_CHANGE, data);
  });

  $rootScope.$on('pusher:call:caller_booted', function onCallerBooted(event, data) {
    $pub(evTypes.CALLER_BOOTED, data);
  });

  return (exp = {
    types: evTypes,

    sub: pubsub._sub,
    unsub: pubsub.unsub,
    once: pubsub.once,
  });
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/pusher-service.js
 ** module id = 161
 ** module chunks = 0
 **/